export default __webpack_public_path__ + "static/media/SuppliersAuditOrangeIcon.090526d6.png";